/**
 * Returns the sorted list by property
 *
 * @param items - The list to be sorted
 * @param key - The key to sort
 */
function sortObjectByProperty(items, key) {
    items.sort((itemA, itemB) => {
        const valueA = itemA[key] ?? Infinity;
        const valueB = itemB[key] ?? Infinity;
        return Number(valueA) - Number(valueB);
    });
}
export { sortObjectByProperty, };
//# sourceMappingURL=sort.js.map